import { useEffect, useState } from 'react'
import { ProductTiersData } from 'types/progressiveDiscountTypes'
import { getProductTiers } from 'services/progressiveDiscountService'

export interface UseProductProgressiveTiersResult {
  tiers: ProductTiersData['tiers']
  rule: ProductTiersData['rule']
  unitPrice: ProductTiersData['unit_price']
  hasDiscount: boolean
  loading: boolean
  error: boolean
}

export function useProductProgressiveTiers(productId: number | undefined): UseProductProgressiveTiersResult {
  const [data, setData] = useState<ProductTiersData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    let cancelled = false

    if (productId) {
      setLoading(true)
      setError(false)

      getProductTiers(productId)
        .then(result => {
          if (!cancelled) {
            setData(result)
            setLoading(false)
          }
        })
        .catch(() => {
          if (!cancelled) {
            setError(true)
            setLoading(false)
          }
        })
    }

    return () => {
      cancelled = true
    }
  }, [productId])

  return {
    tiers: data?.tiers ?? [],
    rule: data?.rule,
    unitPrice: data?.unit_price,
    hasDiscount: data?.has_progressive_discount ?? false,
    loading,
    error,
  }
}
